import React from "react";

const Close = ({ className = "", onCloseButtonClick, icon }) => (
    <div className={`close sign ${className}`} onClick={onCloseButtonClick}>
        {icon ? icon : "X"}
    </div>
);

export default Close;
